const inView = ($el) => {
  let viewOffset = 100;
  let windowView = $(window).height();
  let offset = $el.offset().top;
  return offset - viewOffset <= $(window).scrollTop() + windowView;
};

export default inView;
